import Model from "src/models/base/model.js";

class QuotationInvoice extends Model{
  resourceName() {
    return "quotation_invoices";
  }

  fields() {
    return {
      total_value: "",
      is_blocked: "",
      quotation: {jsonApi: "hasOne", type: "quotations"},
      nfes: {jsonApi: "hasMany", type: "quotation_nfes"},
      ctes: {jsonApi: "hasMany", type: "quotation_ctes"},
    }
  }

  async create(id) {
    return this.request(
      this.resourceName() + "/" + id,
      "POST",
      {},
      {}
    );
  }
}

export default new QuotationInvoice();
